import React from 'react';
import PenIcon from './Pen.icon';
import TrashIcon from './Trash.icon';

export enum HeaderActionIcons {
  EDIT = 'EDIT',
  DELETE = 'DELETE',
}

export const HEADER_ACTIONS_ICONS: { [key: string]: React.ReactNode } = {
  [HeaderActionIcons.EDIT]: <PenIcon />,
  [HeaderActionIcons.DELETE]: <TrashIcon />,
};
